import React, { Component } from 'react'
import { Tabs, Carousel } from 'antd';

import img1 from '../../static/images/surper-1.jpg'
import img2 from '../../static/images/surper-2.jpg'
import img3 from '../../static/images/surper-3.jpg'
import img4 from '../../static/images/surper-4.jpg'
import img5 from '../../static/images/surper-5.jpg'
import product1 from '../../static/images/product-1.png'
import product2 from '../../static/images/product-2.png'
import product3 from '../../static/images/product-3.png'
import product4 from '../../static/images/product-4.png'
import product5 from '../../static/images/product-5.png'
import product6 from '../../static/images/product-6.png'
import product7 from '../../static/images/product-7.png'
import product8 from '../../static/images/product-8.png'

import partner1 from '../../static/images/partner-1.png'
import partner2 from '../../static/images/partner-2.jpg'
import partner3 from '../../static/images/partner-3.webp'
import partner4 from '../../static/images/partner-4.png'
import partner5 from '../../static/images/partner-5.jpeg'
import partner6 from '../../static/images/partner-6.webp'
import partner7 from '../../static/images/partner-7.webp'
import partner8 from '../../static/images/partner-8.webp'
import partner9 from '../../static/images/partner-9.jpeg'
import partner10 from '../../static/images/partner-10.png'
import partner11 from '../../static/images/partner-11.png'
import partner12 from '../../static/images/partner-12.png'
import partner13 from '../../static/images/partner-13.webp'
import partner14 from '../../static/images/partner-14.webp'

import tabImg1 from '../../static/images/tab-img-1.jpg'
import tabImg2 from '../../static/images/tab-img-2.jpg'
import tabImg3 from '../../static/images/tab-img-3.jpg'
import tabImg4 from '../../static/images/tab-img-4.jpg'
import tabImg5 from '../../static/images/tab-img-5.jpg'

import tabImgIcon1 from '../../static/images/index-solution-super-1.png'
import tabImgIcon2 from '../../static/images/index-solution-super-2.png'
import tabImgIcon3 from '../../static/images/index-solution-super-3.png'
import tabImgIcon4 from '../../static/images/index-solution-super-4.png'
import tabImgIcon5 from '../../static/images/index-solution-wuren-1.png'
import tabImgIcon6 from '../../static/images/index-solution-wuren-2.png'
import tabImgIcon7 from '../../static/images/index-solution-wuren-3.png'
import tabImgIcon8 from '../../static/images/index-solution-wuren-4.png'
import tabImgIcon9 from '../../static/images/index-solution-ls-1.png'
import tabImgIcon10 from '../../static/images/index-solution-ls-2.png'
import tabImgIcon11 from '../../static/images/index-solution-ls-3.png'
import tabImgIcon12 from '../../static/images/index-solution-ls-4.png'
import tabImgIcon13 from '../../static/images/index-solution-nm-1.png'
import tabImgIcon14 from '../../static/images/index-solution-nm-2.png'
import tabImgIcon15 from '../../static/images/index-solution-nm-3.png'
import tabImgIcon16 from '../../static/images/index-solution-nm-4.png'
import tabImgIcon17 from '../../static/images/index-solution-shop-1.png'
import tabImgIcon18 from '../../static/images/index-solution-shop-2.png'
import tabImgIcon19 from '../../static/images/index-solution-shop-3.png'
import tabImgIcon20 from '../../static/images/index-solution-shop-4.png'

import custom1 from '../../static/images/custom-ex-1.jpg'
import custom2 from '../../static/images/custom-ex-2.jpg'
import custom3 from '../../static/images/custom-ex-3.jpg'
import custom4 from '../../static/images/custom-ex-4.jpg'
import custom5 from '../../static/images/custom-ex-5.jpg'
import custom6 from '../../static/images/custom-ex-6.jpg'
import custom7 from '../../static/images/custom-ex-7.jpg'
import custom8 from '../../static/images/custom-ex-8.jpg'
import custom9 from '../../static/images/custom-ex-9.jpg'
import custom10 from '../../static/images/custom-ex-10.jpg'
import custom11 from '../../static/images/custom-ex-11.jpg'
import custom12 from '../../static/images/custom-ex-12.jpg'
import custom13 from '../../static/images/custom-ex-13.jpg'
import custom14 from '../../static/images/custom-ex-14.jpg'
import custom15 from '../../static/images/custom-ex-15.jpg'
import custom16 from '../../static/images/custom-ex-16.jpg'
import custom17 from '../../static/images/custom-ex-17.jpg'
import custom18 from '../../static/images/custom-ex-18.jpg'
import custom19 from '../../static/images/custom-ex-19.jpg'


import './home.less';

import wx from 'weixin-js-sdk'
const { TabPane } = Tabs;
// const history = useHistory();

class Home extends Component {
    state = {
        iframeHeight: 600,
         customerList: [
            { img: custom1 },
            { img: custom2 },
            { img: custom3 },
            { img: custom4 },
            { img: custom5 },
            { img: custom6 },
            { img: custom7 },
            { img: custom8 },
            { img: custom9 },
            { img: custom10 },
            { img: custom11 },
            { img: custom12 },
            { img: custom13 },
            { img: custom14 },
            { img: custom15 },
            { img: custom16 },
            { img: custom17 },
            { img: custom18 },
            { img: custom19 },
        ],
        partnerList: [
            { img: partner1 },
            { img: partner2 },
            { img: partner3 },
            { img: partner4 },
            { img: partner5 },
            { img: partner6 },
            { img: partner7 },
            { img: partner8 },
            { img: partner9 },
            { img: partner10 },
            { img: partner11 },
            { img: partner12 },
            { img: partner13 },
            { img: partner14 },
        ],
        carouselList:[
            {img: img1, id: 1},
            { img: img2, id: 2 },
            { img: img3, id: 3 },
            { img: img4, id: 4 },
            { img: img5, id: 5 },
        ],
        carouseTitlelList: [
            { title: '悦喵AI零售', id: 1 },
            { title: '悦喵AI无人', id: 2 },
            { title: '悦喵AI餐饮', id: 3 },
            { title: '悦喵AI会员', id: 4 },
            { title: '悦喵AI商城', id: 5 },
        ],
        activeIndex: 0,
        res: null,
        history: null
    }

    
    onEvents() { }
    
    componentDidMount() {
        console.log('.....componentDidMount....', window.location)
        // this.setState({
        //     history: window.location
        // })
        // alert(JSON.stringify(window.location))
        const openId = window.location.href.split('openId=')[1]
        wx.miniProgram.getEnv((res) => {

            console.log(res, '.....wx.miniProgram.getEnv....')
            this.setState({
                res: 1,
            })
            // if (res.miniprogram) {
            //     wx.miniProgram.navigateTo({
            //         url: '/pages/message/customerService' //如果需要传递参数的话可以通过 url 路径拼接
            //     });
            //     return;
            // } else {
            //     console.log('不在小程序中');
            //     return;
            // }
        });
        wx.miniProgram.navigateBack()
        wx.miniProgram.postMessage({ data: openId })

        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'home-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    render() {
        const { customerList, partnerList, carouselList, carouseTitlelList, iframeHeight } = this.state
        // const [activeIndex, setActiveIndex] = useState(0)
        // let { activeIndex }  = this.state;
        return (
            <div style={{ width: '100%' }}>
                <iframe
                    title="home-static"
                    src={`${process.env.PUBLIC_URL}/static/home/home.html`}
                    style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                    onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="home_container product_container">
            //     <div className="top-home-carousel">
            //         <Carousel autoplay autoplaySpeed={9000}  afterChange={(e) => {
            //             this.setState({
            //                 activeIndex: e,
            //             });
            //         }}>
            //             {/* <div><img className="carousel-img" src={img1} alt=""  /></div>
            //             <div><img className="carousel-img" src={img2} alt="" /></div>
            //             <div><img className="carousel-img" src={img3} alt="" /></div>
            //             <div><img className="carousel-img" src={img4} alt="" /></div>
            //             <div><img className="carousel-img" src={img5} alt="" /></div> */}
            //             {
            //                 carouselList && carouselList.map((item, index) => (
            //                     <div key={index}><img className="carousel-img" src={item.img} alt="" /></div>
            //                 ))
            //             }
            //         </Carousel>
            //         <div className="mode-mark"></div>
            //         <div className="mask-content-top">
            //             <div className="content-home">
            //                 <div className="banner-top-title">悦喵AI{this.state.history}</div>
            //                 <div className="banner-top-tips">专注传统门店智能化和连锁数字化升级改造{this.state.res}</div>
            //             </div>

            //             <div className="carousel-img-dot">
            //                 {/* <div className="carousel-img-dot-list">悦喵AI零售</div>
            //             <div className="carousel-img-dot-list">悦喵AI无人</div>
            //             <div className="carousel-img-dot-list">悦喵AI餐饮</div>
            //             <div className="carousel-img-dot-list">悦喵AI会员</div>
            //             <div className="carousel-img-dot-list">悦喵AI商城</div> */}
            //                 {
            //                     carouseTitlelList && carouseTitlelList.map((item, index) => (
            //                         <div key={index}>
            //                             <div className="carousel-img-dot-list">{item.title}</div>
            //                             {
            //                                 index === this.state.activeIndex && (
            //                                     <div className="list-line" style={{ background: index === this.state.activeIndex ? '#fff' : 'none' }}></div>
            //                                 ) 
            //                             }
                                       
            //                         </div>
                                   
            //                     ))
            //                 }
            //             </div>

            //         </div>
                    
            //     </div>
            //     <div className="common-block-home">
            //         <div className="common-block-home-title">悦喵AI-SAAS系统</div>
            //         <div className="common-block-home-tips">聚焦零售数字化，深耕细分行业，提供更加垂直的行业解决方案</div>
            //         <Tabs className="common-block-tabs" tabPosition="top">
            //             <TabPane tab="商超零售" key="1">
            //                 <div className="img-div">
            //                     <img className="img-div-content" src={tabImg3} alt="" />
            //                 </div>
            //                 <div className="img-div-mask"></div>
            //                 <div className="img-div-mask-content">
            //                     <div className="img-div-mark-title">智慧零售</div>
            //                     <div className="img-div-mark-tips">便利超市</div>
            //                     <div className="img-div-mark-tips">生鲜超市</div>
            //                     <div className="img-div-mark-tips">社区超市</div>
            //                     <div className="img-div-mark-tips">综合超市</div>
            //                 </div>
            //                 <div className="img-div-mask-left-content"></div>
            //                 <div className="img-div-mask-left">
            //                     <div className="mask-left-flex">
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon1} alt="" />
            //                             <div className="mask-left-tips">多级供应商管理，高效协同</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon2} alt="" />
            //                             <div className="mask-left-tips">商品状态，管控商品生命周期</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon3} alt="" />
            //                             <div className="mask-left-tips">多种电子支付，便捷支付</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon4} alt="" />
            //                             <div className="mask-left-tips">多平台互通，全渠道一体化经营</div>
            //                         </div>
            //                     </div>
            //                     {/* <div className="flex-bottom-btn" onClick={() => {
            //                         console.log(2222)
            //                         // history.push({
            //                         //     pathname: '/supermarketRetail',
            //                         // });
            //                         canTurnTo({
            //                             path: "/supermarketRetail",
            //                             name: 'supermarket-page',
            //                             meta: {
            //                                 title: '商超零售解决方案',
            //                                 hideInMenu: false,
            //                                 access: ['student'],
            //                             } })
            //                     }}>了解更多</div> */}
            //                     <a className="flex-bottom-btn" href="/supermarketRetail">了解更多</a>
                               
            //                 </div>
            //             </TabPane>
            //             <TabPane tab="无人值守" key="2">
            //                 <div className="img-div">
            //                     <img className="img-div-content" src={tabImg1} alt="" />
            //                 </div>
            //                 <div className="img-div-mask"></div>
            //                 <div className="img-div-mask-content">
            //                     <div className="img-div-mark-title">无人零售</div>
            //                     <div className="img-div-mark-tips">CBD无人店</div>
            //                     <div className="img-div-mark-tips">社区无人店</div>
            //                     <div className="img-div-mark-tips">园区无人店</div>
            //                 </div>
            //                 <div className="img-div-mask-left-content"></div>
            //                 <div className="img-div-mask-left">
            //                     <div className="mask-left-flex">
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon9} alt="" />
            //                             <div className="mask-left-tips">真人客服远程守护</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon10} alt="" />
            //                             <div className="mask-left-tips">门店智能化管控</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon11} alt="" />
            //                             <div className="mask-left-tips">全天24候营业</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon12} alt="" />
            //                             <div className="mask-left-tips">收银自动化</div>
            //                         </div>
            //                     </div>


            //                     {/* <div className="flex-bottom-btn" onClick={() => {
            //                         // history.push({
            //                         //     pathname: '/chainFranchise',
            //                         // });
            //                     }}>了解更多</div> */}
            //                     <a className="flex-bottom-btn" href="/chainFranchise">了解更多</a>
            //                 </div>

            //             </TabPane>
            //             <TabPane tab="连锁加盟" key="3">
            //                 <div className="img-div">
            //                     <img className="img-div-content" src={tabImg2} alt="" />
            //                 </div>
            //                 <div className="img-div-mask"></div>
            //                 <div className="img-div-mask-content">
            //                     <div className="img-div-mark-title">连锁加盟</div>
            //                     <div className="img-div-mark-tips">连锁便利店</div>
            //                     <div className="img-div-mark-tips">连锁零食店</div>
            //                     <div className="img-div-mark-tips">连锁生鲜店</div>
            //                 </div>
            //                 <div className="img-div-mask-left-content"></div>
            //                 <div className="img-div-mask-left">
            //                     <div className="mask-left-flex">
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon5} alt="" />
            //                             <div className="mask-left-tips">商品总部化</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon6} alt="" />
            //                             <div className="mask-left-tips">进销存数字化</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon7} alt="" />
            //                             <div className="mask-left-tips">智能仓储无纸化</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon8} alt="" />
            //                             <div className="mask-left-tips">会员平台化</div>
            //                         </div>
            //                     </div>
            //                     {/* <div className="flex-bottom-btn" onClick={() => {
            //                         // history.push({
            //                         //     pathname: '/unmannedRetail',
            //                         // });
            //                     }}>了解更多</div> */}
            //                     <a className="flex-bottom-btn" href="/unmannedRetail">了解更多</a>

            //                 </div>
            //             </TabPane>
            //             <TabPane tab="农贸市场" key="4">
            //                 <div className="img-div">
            //                     <img className="img-div-content" src={tabImg4} alt="" />
            //                 </div>
            //                 <div className="img-div-mask"></div>
            //                 <div className="img-div-mask-content">
            //                     <div className="img-div-mark-title">农贸市场</div>
            //                     <div className="img-div-mark-tips">管理平台</div>
            //                     <div className="img-div-mark-tips">信息溯源</div>
            //                     <div className="img-div-mark-tips">智能管理</div>
            //                 </div>
            //                 <div className="img-div-mask-left-content"></div>
            //                 <div className="img-div-mask-left">
            //                     <div className="mask-left-flex">
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon13} alt="" />
            //                             <div className="mask-left-tips">数据管理</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon14} alt="" />
            //                             <div className="mask-left-tips">供应链拓展</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon15} alt="" />
            //                             <div className="mask-left-tips">智慧化经营</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon16} alt="" />
            //                             <div className="mask-left-tips">市场管理</div>
            //                         </div>
            //                     </div>
            //                     <div className="flex-bottom-btn" onClick={() => {
            //                         // history.push({
            //                         //     pathname: '/supermarketRetail',
            //                         // });
            //                     }}>了解更多</div>
            //                 </div>
            //             </TabPane>
            //             <TabPane tab="批订商城" key="5">
            //                 <div className="img-div">
            //                     <img className="img-div-content" src={tabImg5} alt="" />
            //                 </div>
            //                 <div className="img-div-mask"></div>
            //                 <div className="img-div-mask-content">
            //                     <div className="img-div-mark-title">线上商城</div>
            //                     <div className="img-div-mark-tips">B2B模式</div>
            //                     <div className="img-div-mark-tips">S2B模式</div>
            //                     <div className="img-div-mark-tips">B2C模式</div>
            //                 </div>
            //                 <div className="img-div-mask-left-content"></div>
            //                 <div className="img-div-mask-left">
            //                     <div className="mask-left-flex">
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon17} alt="" />
            //                             <div className="mask-left-tips">高效收单方式</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon18} alt="" />
            //                             <div className="mask-left-tips">线上线下数据互通</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon19} alt="" />
            //                             <div className="mask-left-tips">快速收款核账</div>
            //                         </div>
            //                         <div className="img-div-mask-left-list">
            //                             <img className="mask-left-icon" src={tabImgIcon20} alt="" />
            //                             <div className="mask-left-tips">平台数据分析</div>
            //                         </div>
            //                     </div>
            //                     <div className="flex-bottom-btn" onClick={() => {
            //                         // history.push({
            //                         //     pathname: '/supermarketRetail',
            //                         // });
            //                     }}>了解更多</div>
            //                 </div>
            //             </TabPane>
            //         </Tabs>
            //     </div>
            //     <div className="common-block-home product-page">
            //         <div className="common-block-home-title">核心产品和服务</div>
            //         <div className="common-block-home-tips">核心产品 打造多种零售场</div>
            //         <div className="common-block-product">
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product1} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">收银APP</div>
            //                 <div className="product-detail-tips">智能终端助力门店经营提效</div>
            //                 <div className="product-detail-click">详情 &gt;</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product2} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">24h无人值守</div>
            //                 <div className="product-detail-tips">打造24小时营业的无人智能店</div>
            //                 <div className="product-detail-click">详情 &gt;</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product3} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">智慧营销</div>
            //                 <div className="product-detail-tips">高效、精准、全自动的营销能力</div>
            //                 <div className="product-detail-click">详情 &gt;</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product4} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">聚合支付</div>
            //                 <div className="product-detail-tips">轻松聚合各种支付方式，快速对接</div>
            //                 <div className="product-detail-click">详情 &gt;</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product8} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">微商城</div>
            //                 <div className="product-detail-tips">线上和线下无缝连接的商户小程序</div>
            //                 <div className="product-detail-click">详情 &gt;</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product5} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">供应链</div>
            //                 <div className="product-detail-tips">企业专属的数字化订货商城</div>
            //                 <div className="product-detail-click">详情 &gt;</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product6} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">全渠道会员</div>
            //                 <div className="product-detail-tips">微信、支付宝原生电子会员卡</div>
            //                 <div className="product-detail-click">详情 &gt;</div>
            //             </div>
            //             <div className="product-detail">
            //                 <div className="product-detail-img">
            //                     <img className="img-style" src={product7} alt="" />
            //                 </div>
            //                 <div className="product-detail-title">硬件服务</div>
            //                 <div className="product-detail-tips">多类型硬件服务。满足商家需求</div>
            //                 <div className="product-detail-click">详情 &gt;</div>
            //             </div>
                       

                        
            //         </div>
                    
            //     </div>

            //     <div className="common-block-home product-page customer-page">
            //         <div className="common-block-home-title">客户案例</div>
            //         <div className="common-block-product common-customer">
            //             {
            //                 customerList && customerList.map((item, index) => (
            //                     <div className="customer-detail-img" key={index}>
            //                         <img className="img-style" src={item.img} alt="" />
            //                     </div>
            //                 ))
            //             }
                        
            //         </div>
            //     </div>
            //     <div className="common-block-home product-page customer-page partner-page">
            //         <div className="common-block-home-title">合作伙伴</div>
            //         <div className="common-block-product common-customer">
            //             {
            //                 partnerList && partnerList.map((item, index) => (
            //                     <div className="customer-detail-img partner-icon" key={index}>
            //                         <img className="img-style" src={item.img} alt="" />
            //                     </div>
            //                 ))
            //             }

            //         </div>
            //     </div>
            // </div >
        )
    }
}


export default Home